import { render, staticRenderFns } from "./MobileHeader.vue?vue&type=template&id=d1056450&scoped=true&"
import script from "./MobileHeader.vue?vue&type=script&lang=ts&"
export * from "./MobileHeader.vue?vue&type=script&lang=ts&"
import style0 from "./MobileHeader.vue?vue&type=style&index=0&id=d1056450&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1056450",
  null
  
)

export default component.exports